// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  max-width: 100%;
  background-color:white; 
  padding:2%;
  padding-left:4%; 
  padding-right: 4%; 
}
.sub-container{
  width:100%;
  border:2px solid none;
  border-radius:10PX;
  margin: 2%;
  padding: 2%;
}
body{
  background-color: whitesmoke;
}
.spacing {
  margin-left: 40px;
}

.spacing1 {
  margin-left: 200px;
}

#searchButton {
  padding: 8px 10px; 
  font-size: 12px; 
  margin-left: 10px;
}

#email {
  width: 300px;
  padding: 5px; 
  font-size: 15px; 
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3%;
}

.upload-input-file {
  margin: 10px 15px;
  font-size: 12px;
  font-family: Roboto, sans-serif;
  background-color: #286090;
  padding: 10px;
  color: white;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.upload-container {
  display: flex;
  align-items: center;
}

.upload-container label {
  margin-right: 10px;
}

.upload-container input {
  margin-right: 10px;
}
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh; /* Adjust this as needed */
}

mat-spinner {
  margin: auto;
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.center-content {
  margin: auto !important;
  text-align: center;
}
.center-message {
  text-align: center;
  margin-top: 20px;
  font-size: 20em;
  color: #000;;
}
.error-message p {
  color: red;
  font-size: 0.9em;
  margin: 5px 0;
}

.header-container {
  display: flex;              
  flex-direction: column;    
} 
 
.header-label {
  margin-bottom: 8px;        
  font-weight: bold;       
}
 
.filter-input {
  width: 100%;               
  box-sizing: border-box;    
}
:host {
  font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/admin/updategrantor/updategrantor.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,wEAAwE;AAC1E;AACA,o+HAAo+H","sourcesContent":[".container {\n  width: 100%;\n  max-width: 100%;\n  background-color:white; \n  padding:2%;\n  padding-left:4%; \n  padding-right: 4%; \n}\n.sub-container{\n  width:100%;\n  border:2px solid none;\n  border-radius:10PX;\n  margin: 2%;\n  padding: 2%;\n}\nbody{\n  background-color: whitesmoke;\n}\n.spacing {\n  margin-left: 40px;\n}\n\n.spacing1 {\n  margin-left: 200px;\n}\n\n#searchButton {\n  padding: 8px 10px; \n  font-size: 12px; \n  margin-left: 10px;\n}\n\n#email {\n  width: 300px;\n  padding: 5px; \n  font-size: 15px; \n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 3%;\n}\n\n.upload-input-file {\n  margin: 10px 15px;\n  font-size: 12px;\n  font-family: Roboto, sans-serif;\n  background-color: #286090;\n  padding: 10px;\n  color: white;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n}\n\n.upload-container {\n  display: flex;\n  align-items: center;\n}\n\n.upload-container label {\n  margin-right: 10px;\n}\n\n.upload-container input {\n  margin-right: 10px;\n}\n.spinner-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh; /* Adjust this as needed */\n}\n\nmat-spinner {\n  margin: auto;\n  position: absolute;\n  top: 70%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.center-content {\n  margin: auto !important;\n  text-align: center;\n}\n.center-message {\n  text-align: center;\n  margin-top: 20px;\n  font-size: 20em;\n  color: #000;;\n}\n.error-message p {\n  color: red;\n  font-size: 0.9em;\n  margin: 5px 0;\n}\n\n.header-container {\n  display: flex;              \n  flex-direction: column;    \n} \n \n.header-label {\n  margin-bottom: 8px;        \n  font-weight: bold;       \n}\n \n.filter-input {\n  width: 100%;               \n  box-sizing: border-box;    \n}\n:host {\n  font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
